import React from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { ReactComponent as CloseIcon } from '../../../../../../../../../../../../assets/icons/close-grey.svg'
import Field from '../../../../../../../../../../../../components/Form/Field'

import { getAllocationInfo, getAllocationSymbol } from '../../../helpers'

import { ALLOCATION } from '../fields'
import { selectedPartnershipSelector } from '../../../../../../../../../../../../modules/selectors/partnerships'

import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../fields'

import useSelectedItemsTableStyles from '../styles'
import useStyles from './styles'

const SubAllocationMultiFieldItem = ({ formik, name, index, value, label, deleteHandler, className }) => {
  const classes = useStyles()
  const selectedItemsTableClasses = useSelectedItemsTableStyles()

  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = useSelector(selectedPartnershipSelector)

  const { values, errors } = formik

  const { allocationType, allocationGroup, billingEventType, isPercentageAllocation } = getAllocationInfo(values)

  const allocationFieldPath = `${name}[${index}][${allocationGroup}].${ALLOCATION}`

  const allocationFieldHasError = errors?.[name]?.[index]?.[allocationGroup]?.[ALLOCATION]
  const allocationFieldWasTouched = formik.touched?.[name]?.[index]?.[allocationGroup]?.[ALLOCATION]
  const highlightAllocationField = allocationFieldHasError && allocationFieldWasTouched

  const priceFieldHasError = errors?.[name]?.[index]?.[billingEventType]
  const priceFieldWasTouched = formik.touched?.[name]?.[index]?.[billingEventType]
  const highlightPriceField = priceFieldHasError && priceFieldWasTouched

  return (
    <div className={selectedItemsTableClasses.container}>
      <div className={classnames(selectedItemsTableClasses.row, className)}>
        <div className={classnames(selectedItemsTableClasses.label)}>{label}</div>
        <Field
          formik={formik}
          key={allocationFieldPath}
          name={allocationFieldPath}
          type="number"
          className={classnames(selectedItemsTableClasses.inlineField, {
            [classes.hasError]: highlightAllocationField
          })}
          symbol={getAllocationSymbol(isPercentageAllocation, allocationType, gamAccount?.currency_symbol)}
          symbolPosition={isPercentageAllocation ? 'end' : 'start'}
          // We don't show the error message because Field doesn't take full width here and there is no enough space
          // we show red border instead
          hideErrorMessage={true}
        />
        <Field
          key={`${name}[${index}].${billingEventType}`}
          formik={formik}
          name={`${name}[${index}].${billingEventType}`}
          type="number"
          className={classnames(selectedItemsTableClasses.inlineField, {
            [classes.hasError]: highlightPriceField
          })}
          symbol={gamAccount?.currency_symbol}
          // We don't show the error message because Field doesn't take full width here and there is no enough space
          // we show red border instead
          hideErrorMessage={true}
        />
        <CloseIcon onClick={() => deleteHandler(value)} className={selectedItemsTableClasses.selectedValueRemove} />
      </div>
    </div>
  )
}

export default SubAllocationMultiFieldItem
